module.exports = __webpack_public_path__ + "img/nav-expenses.d9bd715b.svg";